module.exports = __webpack_public_path__ + "img/Sailec-Medium.d6b141e6.svg";